import React, { Component } from 'react';

import './App.css';

import DesktopHeader from './Header/DesktopHeader';
import MobileHeader from './Header/MobileHeader';

class Header extends Component {
  render() {
    return (
        <header id="topMenu">
          <DesktopHeader />
          <MobileHeader />
        </header>

    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js